import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMRadioGroup } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
  TabIMFormStyled,
} from 'components/common/initiate-proposal/styles';
import IMEffectiveDateSelect from 'components/common/form/IMEffectiveDateSelect';
import BasicInfoStepController from 'store/pages/initiate-quote/nedd/basicInfoStepController';
import { DEFAULT_INITIATE_PROPOSAL_FORM_ID } from './constants';

interface Props {
  basicInfoStepController: BasicInfoStepController;
}

const DefaultInitiateProposalForm: React.FC<Props> = observer(({ basicInfoStepController }) => {
  const { form, effectiveDatesConfig, domainProductLineItems, isDomainProductLinesLoading } = basicInfoStepController;

  return (
    <TabIMFormStyled id={DEFAULT_INITIATE_PROPOSAL_FORM_ID} formController={form}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMEffectiveDateSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesConfig} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />
      {form.fields.nhPublicSector ? (
        <>
          <FollowingSectionTitleStyled title="Additional Information" />
          <IMRadioGroup
            label="Is the group you are enrolling a New Hampshire public sector group (i.e. town, city, county, school,
              quasi-municipal)?"
            name="nhPublicSector"
            radioButtons={[
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ]}
          />
        </>
      ) : null}

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </TabIMFormStyled>
  );
});

export default DefaultInitiateProposalForm;
